module.exports = __webpack_public_path__ + "static/media/ico_adiposidad.137e28c2.svg";